<template>
    <div class="d-none">
        <div :id="model_id" class="modal-box">
            <div class="close-button"> <a href="#" class="modal-close white"></a> </div>
            <div class="modal-container padding0">

                <div id="test" class="form-container">

                    <div class="" style="padding: 4vw 10vw 0vw">
                        <div v-if="showSuccessMsg" class="alert alert-success">
                            Password updated successfully.
                        </div>
                        <div v-if="errors.length">
                            <b>Please correct the following error(s):</b>
                            <ul style="color: red">
                                <li  class="alert alert-danger"  v-for="error in errors">{{ error }}</li>
                            </ul>
                        </div>
                        <div class="form-element">
                            <label for="password" class="title">Old Password</label>
                            <input id="old_password" type="password" v-model="old_password" required>
                        </div>
                        <div class="form-element">
                            <label for="password" class="title">New Password</label>
                            <input id="password" type="password" v-model="password" required>
                        </div>
                        <div class="form-element">
                            <label for="password-confirm" class="title">Confirm New Password</label>
                            <input id="password-confirm" type="password" v-model="password_confirmation" required>
                        </div>
                    </div>

                    <div class="button-container no-margin text-center" style="padding:1vw">
                        <input type="submit" id="change-pass" @click="handleSubmit" class="button pink midsize mid my-3" value="Change">

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'ChangePasswordComponent',
        props: ['modalId'],
        data(){
            return {
                user: null,
                old_password: '',
                password: '',
                password_confirmation: '',
                errors: [],
                showSuccessMsg: false,
                model_id: 'change-password-'+this.modalId
            }
        },
        mounted() {
            this.errors = [];
            if(localStorage.getItem('user_obj')) {
                this.user = JSON.parse(localStorage.getItem('user_obj'));
                // console.log('user');
            }
        },
        watch: {
            modalId: function (val) {
                // console.log('watch');
            }
        },
        methods : {
            resetForm() {
                    this.old_password = '';
                    this.password = '';
                    this.password_confirmation= '';
                    this.errors= [];
                    this.showSuccessMsg= false;
            },
            validate() {

                this.errors = [];

                if (this.password === '') {
                    this.errors.push('New Password is required.');
                }

                if (this.password_confirmation === '') {
                    this.errors.push('Password Confirmation is required.');
                }

                if (this.old_password === '') {
                    this.errors.push('Old Password is required.');
                }


                if (this.password === this.password_confirmation && this.password.length > 0) {

                } else {
                    this.errors.push("Passwords do not match.");
                }

                return this.errors.length == 0;
            },

            handleSubmit(e) {
                this.errors = [];
                this.showSuccessMsg = false;
                e.preventDefault();

                if (this.validate()) {
                    axios.post(this.apiEndPoints.changePassword, {
                        password: this.password,
                        old_password: this.old_password,
                        password_confirmation: this.password_confirmation,
                    })
                        .then(response => {
                            // console.log(response);

                            if (response.data && response.data.status) {

                                if (response.data.status == 'success') {
                                    if (response.data.user && response.data.user.id) {
                                        this.resetUserInLocalStorage(response.data.user);
                                        this.user = response.data.user;
                                        this.$emit('reload', this.user);
                                    }
                                    this.showSuccessMsg = true;
                                     // $.colorbox.close();
                                } else if (response.data.message) {

                                    this.errors.push(response.data.message)
                                } else {
                                    this.errors.push('An error occurred. Please try again!')
                                }
                            }
                        })
                        .catch(error => {
                            this.$refs.recaptcha.reset();
                            console.error(error.response);

                            if (error.response && error.response.status && error.response.status == 419) {
                                this.$router.push({ name: 'sign_in' });
                            }
                        });
                } else {
                }
            }
            },
    }
</script>
